import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from "@angular/core";
import { DeviceDetectorService } from "ngx-device-detector";

import { EarnService } from "@bitwarden/web-vault/app/services/earn/earn.service";
import { Section } from "@bitwarden/web-vault/app/models/types/earn.types";
import { EarnTableStateEnum } from "@bitwarden/web-vault/app/models/enum/earn.enum";
@Component({
  selector: "app-earn",
  templateUrl: "./earn.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: "tw-flex tw-w-full tw-h-full" },
})
export class EarnComponent implements OnInit {
  protected readonly deviceDetector = inject(DeviceDetectorService);
  protected readonly earnService = inject(EarnService);

  ngOnInit(): void {
    this.earnService.updateState();
  }

  versionInHeader = computed(() => {
    const section = this.earnService.breadCrumbState();
    const mask = this.earnService.selectedMask();
    if (section === "publish" && mask) {
      return this.earnService.getMaskDisplayVersion(mask);
    }

    return "";
  });

  selectSection(section: Section) {
    if (section === "create") {
      this.earnService.initializeMask();
    } else {
      this.earnService.selectedMask.set(null);
    }

    this.earnService.activeSection.set(section);
    this.earnService.breadCrumbState.set(EarnTableStateEnum.DRAFT);
  }
}
